import { curry } from 'ramda';
import { IAppState } from '../../redux';

export const selectStepBetByServiceId = curry((serviceId: string, state: IAppState): number => {
  const {
    auction: { configurations },
  } = state;

  const configuration = configurations[serviceId];

  return configuration?.stepBet || 1;
});
